/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Taborganization2Inputs */

const zh_organizationsettings_taborganization2 = /** @type {(inputs: Organizationsettings_Taborganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`组织`)
};

const en_organizationsettings_taborganization2 = /** @type {(inputs: Organizationsettings_Taborganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organization`)
};

const es_organizationsettings_taborganization2 = /** @type {(inputs: Organizationsettings_Taborganization2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Organización`)
};

/**
* | output |
* | --- |
* | "Organization" |
*
* @param {Organizationsettings_Taborganization2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_taborganization2 = /** @type {((inputs?: Organizationsettings_Taborganization2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Taborganization2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_taborganization2(inputs)
	if (locale === "en") return en_organizationsettings_taborganization2(inputs)
	return es_organizationsettings_taborganization2(inputs)
});
export { organizationsettings_taborganization2 as "organizationSettings_tabOrganization" }